import './StatsDetail.scss';

function StatsDetail(props) {
  const { variant = '', children, className: extraClassName, ...rest } = props;

  return (
    <div className={`stat-detail stat-card ${variant} ${extraClassName || ''}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export default StatsDetail;
